import flagsmith from 'flagsmith';

export const getAllFeatureFlags = () => flagsmith.getState()?.flags || null;
